import React, { useState, useEffect } from 'react';
import './Checkout.scss';
import { Helmet } from "react-helmet";
import { Pedclid, Pedclim } from '../../classes/pedido';
import { useSelector, useDispatch } from 'react-redux';
import { createPedido, resetPedidoFetch } from './../../store/pedidos/pedidos.actions';
import Error from './../../components/Error/Error';
import CartItem from '../../components/CartItem/CartItem';
import Button from '../../core/Button/Button';
import Currency from '../../core/Currency/Currency';
import Spinner from '../../core/Spinner/Spinner';
import { Link } from 'react-router-dom';

const Checkout: React.FunctionComponent<{}> = () => {
    const dispatch = useDispatch();
    const { cart } = useSelector((state: any) => state.cartStore);
    const { fetching, error, requestDone } = useSelector((state: any) => state.pedidosStore);
    const [ observaciones, setObservaciones ] = useState<string>('');
    const user = useSelector((state: any) => state.authStore.user);

    useEffect(() => {
        dispatch(resetPedidoFetch());
    }, [dispatch]);

    const getTotal = (): number => {
        let total: number = 0;

        for (let i = 0, N = cart.length; i < N; i++) total += cart[i].PVENTA * cart[i].CANT_PED;

        return Number(total.toFixed(2));
    };

    const getDate = (): string => {
	    const d = new Date(),
		    month = d.getMonth() + 1,
		    day = d.getDate(),
		    year = d.getFullYear();
	
		return `${year}-${month}-${day}`;
    };

    const takeOrder = () => {
        const pedclids: Pedclid[] = cart.filter((c: Pedclid) => c.CANT_PED > 0);

        if (pedclids.length < 1) {
            alert('No tiene artículos en su carrito. Revise las cantidades asignadas a cada artículo.');
            return;
        }

        if (pedclids.length > 20) {
            alert('No puede pedir mas de 20 artículos. Por favor, separelo en distintos pedidos que no superen ese límite.');
            return;
        }

        const pedclim: Pedclim = new Pedclim(-1, '35', getDate(), user.CODCLI, getTotal(), observaciones || '', false, pedclids);
        dispatch(createPedido(pedclim));
        window.scrollTo(0, 0);
    };

    const setObs = (evt: any) => {
        setObservaciones(evt.target.value);
    };

    const renderCart = () => {
        if (error) {
            return <Error msg="Hubo un error al tomar su pedido. Por favor intente nuevamente" />
        }
    
        if (fetching) {
            return <Spinner>Tomando pedido, por favor espere...</Spinner>;
        }
    
        if (requestDone) {
            return <p>Gracias por tomar su pedido. Nos comunicaremos con usted en breve.</p>
        }

        if (!cart || !cart.length) {
            return <p>No hay productos en el carrito</p>;
        }

        return (
            <div>
                <div className="CartList">
                    {cart.map((item: Pedclid, index: number) => <CartItem key={index} {...item} />)}
                </div>
                <p className="CartTotal">TOTAL <b><Currency value={getTotal()} /></b></p>
                <div className="text-right">
                    <Link to='/productos'><Button className="SeguirComprandoBtn">SEGUIR COMPRANDO</Button></Link>
                    <Button 
                        click={takeOrder} 
                        className="TomarPedidoBtn">ENVIAR PEDIDO
                    </Button>
                </div>
                <textarea 
                    placeholder="Observaciones" 
                    value={observaciones}
                    onChange={setObs}
                    className="Observaciones">
                </textarea>
            </div>
        );
    };

    return (
        <div className="container SectionContainer Checkout">
            <Helmet>
                <title>Zalazar Distribuidora | Carrito para pedidos</title>
                <meta name="description" content="Zalazar Distribuidora mayorista y minorista de productos " />
                <meta name="keywords" content="zalazar, distribuidor, distribuidora, mayorista, rosario, supermercados, alimentos, comidas, productos" />
            </Helmet>
            <h3 className="SectionTitle">Carrito de compras</h3>
            {renderCart()}
        </div>
    );
};

export default Checkout;